import { getStyleBySize, SizeStylesDictionary } from '../../utils/styles';

/**
 * Engine select breakpoints.
 */
export type SelectSize = 0 | 275 | 822;

/**
 * All engine select breakpoints named in array.
 */
export const selectSizes = [0, 275, 822] as SelectSize[];

/**
 * Engine select makeStyles props type.
 */
export type StylesProps = { selectSize: number; };

/**
 * Builds function which resolves css property value from size in StyleProps.
 * Use this in makeStyles function of engine select. 
 * @param styles dictionary size - property value 
 * @returns function
 */
export const fromSize = <V extends any>(styles: SizeStylesDictionary<SelectSize, V>) =>
	(props: StylesProps) => getStyleBySize<SelectSize, V>(props.selectSize, styles);
